exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-grid-container[data-v-7cb272a6]{position:relative;flex-shrink:1;display:grid;overflow:auto;-webkit-overflow-scrolling:touch}.vc-grid-cell[data-v-7cb272a6]{display:flex;justify-content:center;align-items:center}", ""]);

// exports
